import { gql } from '@apollo/client';

export const GET_ENFORCE_BRANDING_TYPE = gql`
  query getEnforceBrandingType($teamId: String!) {
    getEnforceBrandingType(teamId: $teamId)
  }
`;

export const SET_ENFORCE_BRANDING_TYPE = gql`
  mutation setEnforceBrandingType($enforceBrandingType: String!, $teamId: String!) {
    setEnforceBrandingType(enforceBrandingType: $enforceBrandingType, teamId: $teamId)
  }
`;

export const GET_LIMIT_FONTS_AND_COLORS = gql`
  query getLimitFontsAndColors($teamId: String!) {
    getLimitFontsAndColors(teamId: $teamId) {
      fonts {
        family
        type
        isDefault
        url
      }
      colors {
        hex
        isDefault
      }
    }
  }
`;

export const SET_LIMIT_COLORS = gql`
  mutation setLimitColors($limitColors: [LimitColorInput!]!, $teamId: String!) {
    setLimitColors(limitColors: $limitColors, teamId: $teamId) {
      fonts {
        family
        type
        isDefault
        url
      }
      colors {
        hex
        isDefault
      }
    }
  }
`;

export const SET_LIMIT_FONTS = gql`
  mutation setLimitFonts($limitFonts: [LimitFontInput!]!, $teamId: String!) {
    setLimitFonts(limitFonts: $limitFonts, teamId: $teamId) {
      fonts {
        family
        type
        isDefault
        url
      }
      colors {
        hex
        isDefault
      }
    }
  }
`;
